import { HttpStateLine, Api, Headers, CheckResult } from 'state-line';
import { getPassToken, getPassTokenSource, goToLogin } from '@xgimi-private/user-center';

// import Cookies from 'js-cookie';
import { formatUrlParams, getUrlParams } from 'xgimi-utils/url';
import ApiCode from '../constants/ApiCode';
import { getEnvValue } from '../appUtils/env';
import { deleteObjKeys } from '../utils/util';

// import { getStore } from '../store';
// import State from '../store/State';

/**
 * Api基类
 */
export default class <T = any> extends Api<T> {
  // 是否需要登录
  protected isLogin: boolean = true;

  // headers
  public headers: Headers = {
    // TODO 可能需要根据当前项目自行配置
    token: decodeURIComponent(getPassToken()),
    source: getPassTokenSource(),
  };

  // 校验请求结果
  public checkResult: CheckResult = (stateLine: HttpStateLine): boolean => (!!stateLine.result && stateLine.result.code === ApiCode.Success) || !stateLine.result;

  // 请求配置
  requestConfig = {
    withCredentials: true,
  };

  // 开始处理 stateLine
  public onRequesting = (): void => {
    // TODO log?
  };

  // 失败处理
  public onFail = (stateLine: HttpStateLine): void => {
    // const state: State = getStore().getState();

    // 未登录
    if (stateLine.result.code === ApiCode.NoLogin) {
      // 前往登录
      if (this.isLogin) goToLogin();
    } else if (stateLine.result.code === ApiCode.WechatNoLogin) { // 登录态失效时
      // 跳转到企业微信获取code时去掉参数中的code和state
      const params = deleteObjKeys(getUrlParams(), ['code', 'state']);
      // eslint-disable-next-line max-len
      window.location.href = `${getEnvValue('REACT_APP_WECHAT_LOGIN')}${encodeURIComponent(`${window.location.origin}${window.location.pathname}?${formatUrlParams(params)}`)}&connect_redirect=1#wechat_redirect`;
    }
    // 失败
    // else if (!stateLine.onFail) {
    //   state.common.message.current?.enqueueSnackbar(stateLine.result.message || stateLine.result.msg || getLanguage()('api.error'), { variant: 'error' });
    // }

    // TODO log?
  };

  // 完成处理 stateLine
  public onFinish = (): void => {
    // TODO log?
  };
}
